import React from 'react';
import { useParameterizedQuery, useMutation } from 'react-fetching-library';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Menu, MenuItem, Divider, ListItem, ListItemIcon, ListItemText, ListItemButton, ListItemSecondaryAction, IconButton, Tooltip, Checkbox, Box, Stack } from '@mui/material';
import { createAgreementAnnexAction, sendAgreementAnnexAction, deleteAgreementAnnexAction, sendDocument, deleteAgreement, createAgreementAction, updateAgreementAnnexAction, sendMailsWithSigningData } from '../../../../../../services/request';
import { updateOrder } from '../../../../../../services/redux-actions';
import AddIcon from '@mui/icons-material/Add';
import ForwardToInboxIcon from '@mui/icons-material/ForwardToInbox';
import DeleteIcon from '@mui/icons-material/Delete';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import RefreshIcon from '@mui/icons-material/Refresh';
import BrushIcon from '@mui/icons-material/Brush';

import SendMessagePreviewModal from './SendMessagePreviewModal';
import ConfirmRefreshAgreementModal from './ConfirmRefreshAgreementModal';
import { ConfirmDialog } from '../../../../../../components/ConfirmDialog';
import Iconify from '../../../../../../components/Iconify';
import toast from 'react-hot-toast';
import { formatDateTime } from '../../../../../../services/functions';
import ConfirmUnsignAgreementModal from '../../../../applications/applicationForm/tabs/documents/ConfirmUnsingAgreementModal';
import DateTimePickerIcon from '../../../../../../components/DateTimePickerIcon';

const AgreementButton = ({ order, getDocument, module }) => {
  const dispatch = useDispatch();
  const { seasonIdentifier, seasonYear } = useSelector(state => state.app);
  const [openPreviewModal, setOpenPreviewModal] = React.useState(false);
  const [openRefreshModal, setOpenRefreshModal] = React.useState(false);
  const [openUnsignModal, setOpenUnsignModal] = React.useState(false);
  const [unsignType, setUnsignType] = React.useState('');
  const [now, setNow] = React.useState(new Date());

  const [refreshType, setRefreshType] = React.useState('');
  const [previewModalData, setPreviewModalData] = React.useState({ handleSend: () => {}, type: '', fileNames: [] });
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [confirmDeleteOpen, setConfirmDeleteOpen] = React.useState(false);
  const [deleteData, setDeleteData] = React.useState({});
  const { query } = useParameterizedQuery(createAgreementAnnexAction);
  const { query: queryAgreement } = useParameterizedQuery(createAgreementAction);
  const { query: sendQuery } = useParameterizedQuery(sendAgreementAnnexAction);
  const { query: sendAgreementQuery } = useParameterizedQuery(sendDocument);
  const { query: sendMailsWithSigningDataQuery } = useParameterizedQuery(sendMailsWithSigningData);
  const { mutate } = useMutation(deleteAgreementAnnexAction);
  const { mutate: mutateDeleteAgreement } = useMutation(deleteAgreement);
  const { mutate: updateAnnex } = useMutation(updateAgreementAnnexAction);
  const open = Boolean(anchorEl);

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleCreateAgreement = async () => {
    console.log(order.id);
    const { payload, error, loading } = await queryAgreement(order.id);
    if (!error && !loading) {
      dispatch(updateOrder(payload));
      toast.success('Utworzono umowę');
    }

    if (error) {
      toast.error('Nie udało się utworzyć umowy');
    }
  };

  const handleCreateAnnex = async () => {
    const { payload, error, loading } = await query(order.id);
    if (!error && !loading) {
      dispatch(updateOrder(payload));
      toast.success('Utworzono aneks');
    }

    if (error) {
      toast.error('Nie udało się utworzyć aneksu');
    }
  };

  const handleSendAnnex = async (annex_id, data) => {
    const { error, loading } = await sendQuery(order.id, annex_id, data);
    if (!error && !loading) {
      toast.success('Email został wysłany');
      setOpenPreviewModal(false);
    }

    if (error) {
      toast.error('Nie udało się wysłać aneksu');
    }
  };

  const handleConfirmDelete = (annexId, type) => {
    setConfirmDeleteOpen(true);
    if (type == 'aneks') {
      setDeleteData({ id: annexId, type: 'aneks' });
    } else if (type == 'umowa') {
      setDeleteData({ id: null, type: 'umowa' });
    }
  };

  const handleDelete = async () => {
    const { error: mutateError } = await mutate(deleteData.id);
    if (!mutateError) {
      dispatch(updateOrder({ ...order, order_annexes: order.order_annexes.filter(annex => annex.id !== deleteData.id) }));
      toast.success('Aneks został usunięty');
    } else {
      toast.error('Nie udało się usunąć aneksu');
    }
    setConfirmDeleteOpen(false);
    setDeleteData({});
  };

  const handleDeleteAgreement = async () => {
    const { payload, error: mutateError } = await mutateDeleteAgreement(order.id);
    if (!mutateError) {
      dispatch(updateOrder(payload));
      toast.success('Umowa została usunięta');
    } else {
      toast.error('Nie udało się usunąć umowy');
    }
    setConfirmDeleteOpen(false);
    setDeleteData({});
  };

  const getTemplateName = (templateName, isSigned) => {
    if (module === 'zielone_szkoly') {
      if (seasonIdentifier === 'l_24_zs') {
        return `${templateName}_zs_2024`;
      }

      if (seasonIdentifier === 'l_25_zs') {
        return `${templateName}_zs_2025`;
      }

      if (seasonYear >= 2026) {
        if (order.use_contract_payer_data) {
          return `${templateName}_zs_payer_${seasonYear}${isSigned ? '_signed' : ''}`;
        }

        return `${templateName}_zs_${seasonYear}${isSigned ? '_signed' : ''}`;
      }
    } else if (module === 'polkolonie') {
      return `${templateName}_polkolonie`;
    } else if (module === 'wyjazdy_rodzinne') {
      if (isSigned) {
        return `${templateName}_wr_${seasonYear}_signed`;
      }

      return `${templateName}_wr_${seasonYear}`;

    }

    if (seasonYear == 2024) {
      return `${templateName}_2024`;
    }
    if (isSigned) {

      return `${templateName}_${seasonYear}_signed`;
    }

    return `${templateName}_${seasonYear}`;

  };

  const handleSendAgreement = async data => {
    const { error, loading } = await sendAgreementQuery(order.id, getTemplateName('agreement'), data, `umowa nr ${order.agreement_number}`);
    if (!error && !loading) {
      toast.success('Email został wysłany');
      setOpenPreviewModal(false);
    }

    if (error) {
      toast.error('Nie udało się wysłać aneksu');
    }
  };

  const handleSendDocumentSignLink = async data => {
    const extendedData = {
      ...data,
      model: 'Order',
      signing_link_template: data.isAnnex ? 'SESX' : 'SESA',
      signing_code_template: data.isAnnex ? 'SDDA' : 'SDDC'
    };
    const { error, loading } = await sendMailsWithSigningDataQuery(order.id, extendedData);
    if (!error && !loading) {
      toast.success('Email został wysłany');
      setOpenPreviewModal(false);
    }

    if (error) {
      toast.error('Nie udało się wysłać emaila');
    }
  };

  const handleOpenPreviewModal = (handleSend, type, fileNames) => {
    setPreviewModalData({ handleSend, type, fileNames });
    setOpenPreviewModal(true);
  };

  const handleClosePreviewModal = () => setOpenPreviewModal(false);

  const handleConfirmAnnexReturn = async (e, id) => {
    const { error, payload } = await updateAnnex(id, { 'annex_return': e.target.checked });
    if (!error) {
      dispatch(updateOrder({ ...order, order_annexes: order.order_annexes.map(annex => annex.id === id ? payload : annex) }));
      if (e.target.checked === true) {
        toast.success('Zwrot został zaznaczony');
      } else {
        toast.success('Zwrot został odznaczony');
      }
    } else {
      // eslint-disable-next-line no-lonely-if
      if (e.target.checked === true) {
        toast.error('Nie udało się zaznaczyć zwrotu');
      } else {
        toast.error('Nie udało się odznaczyć zwrotu');
      }
    }
  };

  return (
    <>
      <Button
        id="basic-button"
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
        variant="contained"
        // disabled={order.state !== 'CON'}
      >
        Umowa lub ostatni aneks
      </Button>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button'
        }}
      >
        <MenuItem onClick={order.agreement_number !== '' ? handleCreateAnnex : handleCreateAgreement} disabled={order.state !== 'CON'}>
          <ListItemIcon>
            <AddIcon />
          </ListItemIcon>
          <ListItemText>
            {order.agreement_number === ''
              ? 'Dodaj umowe'
              : 'Dodaj aneks'}
          </ListItemText>
        </MenuItem>
        <Divider />
        {order.agreement_number !== ''
          ? <ListItem sx={{ pr: '254px' }} disablePadding>
            <ListItemButton
              onClick={() => getDocument(getTemplateName('agreement', order.agreement_is_signed), `Umowa nr ${order.agreement_number}`)}
            >
              <ListItemText>{order.agreement_number}</ListItemText>
            </ListItemButton>
            <ListItemSecondaryAction sx={{ width: '250px', display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
              <IconButton edge="end" aria-label="comments" onClick={() => getDocument(getTemplateName('agreement', order.agreement_is_signed), 'umowa', 0, true)}>
                <RemoveRedEyeIcon color="primary"/>
              </IconButton>
              {order.order_annexes.length === 0
                ? <>
                  <IconButton disabled={order.state !== 'CON' || order.agreement_is_signed} edge="end" aria-label="comments" onClick={() => handleConfirmDelete(null, 'umowa')}>
                    <DeleteIcon color="error"/>
                  </IconButton>
                  {seasonYear < 2026 && <Tooltip title="wyślij dokument do klienta" placement="right-start">
                    <IconButton
                      edge="end"
                      aria-label="comments"
                      onClick={() => handleOpenPreviewModal(handleSendAgreement, 'SAGR', [`${order.agreement_number}`])}
                      disabled={order.state !== 'CON'}>
                      <ForwardToInboxIcon color="primary"/>
                    </IconButton>
                  </Tooltip>}
                  <IconButton edge="end" aria-label="comments" onClick={() => {
                    setOpenRefreshModal(true);
                    setRefreshType('agreement');
                  }}
                  disabled={order.state !== 'CON' || order.agreement_is_signed}>
                    <RefreshIcon color="secondary"/>
                  </IconButton>
                  { !order.agreement_is_signed
                    ? <DateTimePickerIcon
                      order={order}
                      tooltipTitle={`Termin na podpisanie umowy: ${formatDateTime(order.agreement_signing_due_date)}`}
                      value={order.agreement_signing_due_date}
                      fieldName="signing_due_date"
                      formikFieldName="agreement_signing_due_date"
                      icon="mdi:calendar-clock-outline"
                      type="agreement"
                      disabled={order.state !== 'CON'}
                    /> : null }
                  { order.agreement_is_signed
                    ? <Tooltip title="usuń podpis" placement="right-start">
                      <IconButton edge="end" aria-label="comments" onClick={() => {
                        setOpenUnsignModal(true);
                        setUnsignType('agreement');
                      }}
                      disabled>
                        <Iconify icon="mdi:eraser" style="color:#3366FF" />
                      </IconButton>
                    </Tooltip> : null}
                  { !order.agreement_is_signed && new Date(order.agreement_signing_due_date) > now
                    ? <Tooltip title="wyślij link do podpisu elektronicznego" placement="right-start">
                      <IconButton
                        edge="end"
                        aria-label="comments"
                        onClick={() => handleOpenPreviewModal(values => handleSendDocumentSignLink({ ...values, isAnnex: false }), 'SESA', [])}
                        disabled={order.state !== 'CON'}
                      >
                        <ForwardToInboxIcon color="secondary"/>
                      </IconButton>
                    </Tooltip> : null }
                </>
                : null}
              {order.agreement_is_signed &&
                <Tooltip title={`Umowa podpisana elektronicznie dnia ${formatDateTime(order.agreement_signing_date)}`} ml={0.5}>
                  <Stack alignItems="center" justifyContent="center">
                    <BrushIcon color="secondary" />
                  </Stack>
                </Tooltip>
              }
            </ListItemSecondaryAction>
          </ListItem>
          : null}

        {order.order_annexes.map((annex, index) => (
          <ListItem
            key={annex.id}
            sx={{ pr: '204px' }}
            disablePadding
          >
            <ListItemButton
              onClick={() => getDocument(getTemplateName('agreement_annex', annex.is_signed), `Aneks nr ${annex.number} do umowy ${order.agreement_number}`, annex.id)}
            >
              <ListItemText>Aneks nr {annex.number}</ListItemText>
            </ListItemButton>
            <ListItemSecondaryAction sx={{ width: module === 'zielone_szkoly' ? '200px' : '200px', display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
              <IconButton edge="end" aria-label="comments" onClick={() => getDocument(getTemplateName('agreement_annex', annex.is_signed), `Aneks nr ${annex.number} do umowy ${order.agreement_number}`, annex.id, true)}>
                <RemoveRedEyeIcon color="primary"/>
              </IconButton>
              {index === order.order_annexes.length - 1
                ? <>
                  <IconButton edge="end" aria-label="comments" onClick={() => handleConfirmDelete(annex.id, 'aneks')} disabled={order.state !== 'CON' || annex.is_signed}>
                    <DeleteIcon color="error"/>
                  </IconButton>
                  {seasonIdentifier == 'l_25_zs' && <Tooltip title="wyślij dokument do klienta" placement="right-start">
                    <IconButton
                      edge="end"
                      aria-label="comments"
                      onClick={() => handleOpenPreviewModal(data => handleSendAnnex(annex.id, data), 'SANX', [`Aneks nr ${annex.number} do umowy ${order.agreement_number}`])}
                      disabled={order.state !== 'CON'}>
                      <ForwardToInboxIcon color="primary"/>
                    </IconButton>
                  </Tooltip>}
                  {(module === 'zielone_szkoly' && seasonYear < 2026) ? <IconButton edge="end" aria-label="comments" onClick={() => {
                    setOpenRefreshModal(true);
                    setRefreshType('annex');
                  }}
                  disabled={order.state !== 'CON'}>
                    <RefreshIcon color="secondary"/>
                  </IconButton> : null}
                  { ['l_25', 'l_26', 'l_27', 'l_25_wr', 'l_26_wr', 'l_27_wr', 'l_26_zs', 'l_27_zs'].includes(seasonIdentifier) && !annex.signing_date ? <DateTimePickerIcon
                    order={order}
                    tooltipTitle={`Termin na podpisanie aneksu: ${formatDateTime(annex.signing_due_date)}`}
                    value={annex.signing_due_date}
                    fieldName="signing_due_date"
                    icon="mdi:calendar-clock-outline"
                    annexId={annex.id}
                    type="annex"
                    disabled={order.state !== 'CON'}
                  /> : null}
                  { ['l_25', 'l_26', 'l_27', 'l_25_wr', 'l_26_wr', 'l_27_wr', 'l_26_zs', 'l_27_zs'].includes(seasonIdentifier) && (!annex.is_signed && new Date(annex.signing_due_date) > now)
                    ? <Tooltip title="wyślij link do podpisu elektronicznego" placement="right-start">
                      <IconButton
                        edge="end"
                        aria-label="comments"
                        onClick={() => handleOpenPreviewModal(values => handleSendDocumentSignLink({ ...values, isAnnex: true }), 'SESX', [])}
                        disabled={order.state !== 'CON'}
                      >
                        <ForwardToInboxIcon color="secondary"/>
                      </IconButton>
                    </Tooltip> : null}
                  {annex.is_signed && <Stack justifyContent="center" alignItems="center" ml={index === order.order_annexes.length - 1 ? 0 : 1}>
                    <Tooltip title={`Aneks podpisany elektronicznie dnia ${formatDateTime(annex.signing_date)}`}>
                      <BrushIcon color="secondary" />
                    </Tooltip>
                  </Stack>}
                </>
                : <Box width={80}/>}
              <Tooltip title="zwrot aneksu" placement="right-start" disableInteractive>
                <span>
                  <Checkbox
                    disabled={['l_25', 'l_26', 'l_27', 'l_25_wr', 'l_26_wr', 'l_27_wr', 'l_26_zs', 'l_27_zs'].includes(seasonIdentifier) || order.state !== 'CON'}
                    edge="end"
                    checked={annex.annex_return}
                    onChange={e => handleConfirmAnnexReturn(e, annex.id)}
                    sx={{ pointerEvents: 'auto' }}
                  />
                </span>
              </Tooltip>
            </ListItemSecondaryAction>
          </ListItem>
        ))}
      </Menu>
      {openPreviewModal
        ? <SendMessagePreviewModal
          handleSend={previewModalData.handleSend}
          handleClose={handleClosePreviewModal}
          fileNames={previewModalData.fileNames}
          type={previewModalData.type}/>
        : null}
      {openRefreshModal ? <ConfirmRefreshAgreementModal handleClose={() => setOpenRefreshModal(false)} order={order} type={refreshType}/> : null}
      {openUnsignModal ? <ConfirmUnsignAgreementModal handleClose={() => setOpenUnsignModal(false)} order={order} type={unsignType} /> : null}
      <ConfirmDialog
        title={deleteData.type == 'umowa' ? 'Czy na pewno chcesz usunąć tę umowę?' : 'Czy na pewno chcesz usunąć ten aneks?'}
        open={confirmDeleteOpen}
        setOpen={setConfirmDeleteOpen}
        onConfirm={deleteData.type == 'umowa' ? handleDeleteAgreement : handleDelete}
      >
        Czy na pewno chcesz dokonać tej zmiany? <p></p><b style={{ fontSize: 18, color: 'red' }}>Zostanie ona automatycznie zapisana</b>
      </ConfirmDialog>
    </>
  );
};


export default AgreementButton;
